import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import Crotch from './Common';
import content from './content';
import NotFound from '../NotFound';

function Courses() {
  return (
    <Router>
      <Switch>
        {content.coursesList.map((item) => (
          <Route exact path={`/${content.path}/${item.id}`} key={`route_${item.id}`}>
            <item.component img={item.img} />
          </Route>
        ))}
        <Route exact path={`/${content.path}`}>
          <Crotch />
        </Route>
        <Route>
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
}

export default Courses;
